import { Component, Input } from '@angular/core';

/* istanbul:ignore-next */
@Component({
  selector: 'nv-sidebar-list-header',
  template: require('./nv-sidebar-list-header.component.html'),
  styles: [require('./nv-sidebar-list-header.component.scss')],
})
export class NvSidebarListHeaderComponent {
  @Input() title: string;

  private pulse: boolean = false;
  private _subtitle: string;
  @Input() set subtitle(str: string) {
    this._subtitle = str;
    if (this.shouldAnimateSubtitle) {
      this.pulse = true;
      setTimeout(() => {
        this.pulse = false;
      }, 150);
    }
  }
  get subtitle() {
    return this._subtitle;
  }

  @Input() shouldAnimateSubtitle: boolean;
}
